export default [
  {
    id: 100653,
    name: '#1| NASA | Noobs Welcome | Conquest 40Hz',
    mapImage: 'https://i.ibb.co/hVTxX8P/siege-of-shanghai.jpg',
    countryFlag: 'https://i.ibb.co/kBrCFMj/germany-flag.png',
    mode: 'conquest large',
    map: 'siege of shanghai',
    preset: 'normal',
    tickrate: '40',
    players: '63',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 200542,
    name: '+1 ANARCHY HARDCORE! 60Hz',
    mapImage: 'https://i.ibb.co/3rKyyt4/operation-whiteout.jpg',
    countryFlag: 'https://i.ibb.co/5kS2nqZ/russia-flag.jpg',
    mode: 'conquest large',
    map: 'hammerhead',
    preset: 'hardcore',
    tickrate: '60',
    players: '55',
    ping: '61',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 300765,
    name: 'SUPER@ [SiC] S2 Operation Locker - EPS - 60Hz',
    mapImage: 'https://i.ibb.co/SXYD1Ls/operation-locker.jpg',
    countryFlag: 'https://i.ibb.co/kBrCFMj/germany-flag.png',
    mode: 'conquest large',
    map: 'Operation Locker',
    preset: 'normal',
    tickrate: '60',
    players: '60',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 400172,
    name: 'FEAR CLAN__ Mbl u3 70x__ NO CHEATERS 150%** 25RUS**//_MX_/',
    mapImage: 'https://i.ibb.co/Fg0SWTT/golmud-railway.jpg',
    countryFlag: 'https://i.ibb.co/5kS2nqZ/russia-flag.jpg',
    mode: 'conquest large',
    map: 'golmud railway',
    preset: 'hardcore',
    tickrate: '30',
    players: '62',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 500539,
    name: '.#4 [E4GL] 60Hz - Locker only - Limited Explosives',
    mapImage: 'https://i.ibb.co/3rKyyt4/operation-whiteout.jpg',
    countryFlag: 'https://i.ibb.co/kBrCFMj/germany-flag.png',
    mode: 'conquest large',
    map: 'Operation Locker',
    preset: 'hardcore',
    tickrate: '60',
    players: '61',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 600246,
    name: '!1 [AE51] The Madhouse [ CQL | Fast Spawn | Map Voting ]',
    mapImage: 'https://i.ibb.co/hHwS4PS/lancang-dam.jpg',
    countryFlag: 'https://i.ibb.co/7yqdgbh/uk-flag.jpg',
    mode: 'conquest large',
    map: 'lancang dam',
    preset: 'normal',
    tickrate: '30',
    players: '59',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 700236,
    name: '! Flubber',
    mapImage: 'https://i.ibb.co/vv1NWmt/propaganda.jpg',
    countryFlag: 'https://i.ibb.co/VVh6DTW/america-flag.jpg',
    mode: 'conquest large',
    map: 'propaganda',
    preset: 'normal',
    tickrate: '40',
    players: '64',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
  {
    id: 800426,
    name: '[JGP] - Secound Assault {BF4DM,VOTE,CMD,SPECTATE,RULES}',
    mapImage: 'https://i.ibb.co/hHwS4PS/lancang-dam.jpg',
    countryFlag: 'https://i.ibb.co/F61t04W/netherlands-flag.jpg',
    mode: 'conquest large',
    map: 'lancang dam',
    preset: 'normal',
    tickrate: '60',
    players: '64',
    ping: '47',
    descr: 'Server protected by The_K-50 AntiCheat. Vip !Rules, Questions, Request, Appeal, Visit us: www.epg.gg | Discord https://discord.gg/3r5NK4d',
  },
]